import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BasicHeader from './pages/common/basic-header/BasicHeader';
import Home from './pages/home/Home';
import Footer from 'pages/common/footer/Footer';
import { MainRoutes } from './routes/Pages/Pages';
import CalculatorForm from 'components/calculator-form/CalculatorForm';
import SearchResultsPage from 'components/search-result/searchResultsPage';
import ActivityDetails from 'components/activity-details/ActivityDetails';
import Loader from 'components/loader/Loader';

const App = () => {
  return (
    <div className='App'>
      <BasicHeader />
      <Suspense
        fallback={
          <div>
            <Loader />
          </div>
        }
      >
        <Routes>
          {/* Home Route */}
          <Route path='/' element={<Home />} />
          {/* Map MainRoutes */}
          {MainRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
          <Route path='/calculators/:id' element={<CalculatorForm />} />
          <Route path='/search' element={<SearchResultsPage />} />
          <Route path='/activities/:id' element={<ActivityDetails />} />
        </Routes>
      </Suspense>
      <Footer />
    </div>
  );
};

export default App;
